import { CalcRuntimeError, CalcType, cidForDirItemId, ConceptValueModelList, ExecutableCalc, ExecutableCalcCalculateFunction, ExecutableCalcCalculateOk, Physician, PhysicianListConcept } from "@fusion-advantage/formlib"
import { ok, Result } from "neverthrow"
import { ValidityDeterminate } from '@fusion-advantage/backcompat'

export const createPcpValidationCalc = (): ExecutableCalc => {
	const calculate: ExecutableCalcCalculateFunction = (ctx): Result<ExecutableCalcCalculateOk, CalcRuntimeError> => {
		const models = new ConceptValueModelList<Physician>(ctx.statusValue(PhysicianListConcept.cid))
		const hasPcp = models.list.some(model => model.IsPCP)
		const lackOfPcp = ctx.statusValue(cidForDirItemId(670))
		const patientRefuses = ctx.statusValue(cidForDirItemId(903))

		if(hasPcp) {
			return ok({ calcType: CalcType.Validation, returnValue: { determinate: ValidityDeterminate.Valid }})
		}

		if(!lackOfPcp && !patientRefuses) {
			return ok({ 
				calcType: CalcType.Validation, 
				returnValue: { 
					determinate: ValidityDeterminate.Invalid,
					message: 'Select or add a PCP to table or indicate lack of PCP or patient refusal.'
				}
			})
		}

		return ok({ calcType: CalcType.Validation, returnValue: { determinate: ValidityDeterminate.Valid }})
	}
	return new ExecutableCalc({
		calcType: CalcType.Validation,
		outputCid: PhysicianListConcept.cid,
		// 670 = Lack of PCP
		// 903 = Patient refuses or can’t supply PCP name
		inputCids: [PhysicianListConcept.cid, cidForDirItemId(670), cidForDirItemId(903)],
		selectCalculate: () => calculate
	})
}

